var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 100,
	"./layouts/card/style.module.scss": 100,
	"./layouts/components/breadcrumbs": 123,
	"./layouts/components/breadcrumbs/": 123,
	"./layouts/components/breadcrumbs/index": 123,
	"./layouts/components/breadcrumbs/index.tsx": 123,
	"./layouts/components/breadcrumbs/style.module": 183,
	"./layouts/components/breadcrumbs/style.module.scss": 183,
	"./layouts/components/container": 44,
	"./layouts/components/container/": 44,
	"./layouts/components/container/index": 44,
	"./layouts/components/container/index.tsx": 44,
	"./layouts/components/container/style.module": 125,
	"./layouts/components/container/style.module.scss": 125,
	"./layouts/components/footer": 124,
	"./layouts/components/footer/": 124,
	"./layouts/components/footer/index": 124,
	"./layouts/components/footer/index.tsx": 124,
	"./layouts/components/footer/style.module": 87,
	"./layouts/components/footer/style.module.scss": 87,
	"./layouts/components/loading_indicator": 55,
	"./layouts/components/loading_indicator/": 55,
	"./layouts/components/loading_indicator/index": 55,
	"./layouts/components/loading_indicator/index.tsx": 55,
	"./layouts/components/nav_bar": 98,
	"./layouts/components/nav_bar/": 98,
	"./layouts/components/nav_bar/index": 98,
	"./layouts/components/nav_bar/index.tsx": 98,
	"./layouts/components/nav_bar/standalone": 342,
	"./layouts/components/nav_bar/standalone.tsx": 342,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 86,
	"./layouts/components/notice_banner/": 86,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 184,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 184,
	"./layouts/components/notice_banner/index": 86,
	"./layouts/components/notice_banner/index.tsx": 86,
	"./layouts/components/notice_banner/standalone": 343,
	"./layouts/components/notice_banner/standalone.tsx": 343,
	"./layouts/components/notice_banner/style.module": 185,
	"./layouts/components/notice_banner/style.module.scss": 185,
	"./layouts/page": 99,
	"./layouts/page/": 99,
	"./layouts/page/index": 99,
	"./layouts/page/index.tsx": 99,
	"./layouts/page/style.module": 88,
	"./layouts/page/style.module.scss": 88,
	"./layouts/types": 344,
	"./layouts/types.ts": 344,
	"./marketing/pages/home/toefl": 1605,
	"./marketing/pages/home/toefl/": 1605,
	"./marketing/pages/home/toefl/index": 1605,
	"./marketing/pages/home/toefl/index.tsx": 1605,
	"./marketing/pages/home/toefl/sections/ai": 1199,
	"./marketing/pages/home/toefl/sections/ai/": 1199,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1869,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1869,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1870,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1870,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1871,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1871,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1872,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1872,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1873,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1873,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1874,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1874,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1875,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1875,
	"./marketing/pages/home/toefl/sections/ai/index": 1199,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1199,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1876,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1876,
	"./marketing/pages/home/toefl/sections/apps": 1200,
	"./marketing/pages/home/toefl/sections/apps/": 1200,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1877,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1877,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1878,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1878,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1879,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1879,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1880,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1880,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1881,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1881,
	"./marketing/pages/home/toefl/sections/apps/index": 1200,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1200,
	"./marketing/pages/home/toefl/sections/features": 1201,
	"./marketing/pages/home/toefl/sections/features/": 1201,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1882,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1882,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1883,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1883,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1884,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1884,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1885,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1885,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1886,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1886,
	"./marketing/pages/home/toefl/sections/features/index": 1201,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1201,
	"./marketing/pages/home/toefl/sections/official_questions": 1205,
	"./marketing/pages/home/toefl/sections/official_questions/": 1205,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1895,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1895,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1205,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1205,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 741,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 741,
	"./marketing/pages/home/toefl/sections/value_props": 1202,
	"./marketing/pages/home/toefl/sections/value_props/": 1202,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1887,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1887,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1888,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1888,
	"./marketing/pages/home/toefl/sections/value_props/index": 1202,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1202,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2273,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2273,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1203,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1203,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1889,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1889,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1890,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1890,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1891,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1891,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1892,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1892,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1893,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1893,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1203,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1203,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 740,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 740,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1204,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1204,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1894,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1894,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1204,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1204,
	"./marketing/pages/home/toefl/style.module": 1896,
	"./marketing/pages/home/toefl/style.module.scss": 1896,
	"./marketing/pages/plans/toefl": 1606,
	"./marketing/pages/plans/toefl/": 1606,
	"./marketing/pages/plans/toefl/index": 1606,
	"./marketing/pages/plans/toefl/index.tsx": 1606,
	"./marketing/pages/plans/toefl/sections/testimonials": 1206,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1206,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1897,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1897,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1898,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1898,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1206,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2613;